import { METHOD } from 'services/method'

export const API_SETTING_POINT_COLLECTION = {
    LIST: {
        api: '/v1/dashboard-admin/loyalty-program/setting',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/loyalty-program/setting',
        method: METHOD.PUT,
    },
}
